document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-promo-copy]');
  if (!button) return;

  const value = button.getAttribute('data-copy-value');
  if (!value) return;

  const markCopied = () => {
    button.setAttribute('data-copied', 'true');
    clearTimeout(button._promoCopyTimeout);
    button._promoCopyTimeout = setTimeout(() => {
      button.removeAttribute('data-copied');
    }, 1800);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(value).then(markCopied).catch(() => {
      fallbackCopy(value);
      markCopied();
    });
  } else {
    fallbackCopy(value);
    markCopied();
  }
});

function fallbackCopy(value) {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand('copy');
  } catch (error) {
    // Clipboard copy is not available in this environment; the code remains visible for manual copy.
  }
  document.body.removeChild(textarea);
}
